import { render, staticRenderFns } from "./WhatCanYouDo.vue?vue&type=template&id=c4130168&scoped=true&"
import script from "./WhatCanYouDo.vue?vue&type=script&lang=js&"
export * from "./WhatCanYouDo.vue?vue&type=script&lang=js&"
import style0 from "./WhatCanYouDo.vue?vue&type=style&index=0&id=c4130168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4130168",
  null
  
)

export default component.exports